<div class="inline-flex" *ngIf="visible">
  <p-button
    [styleClass]="spacing + ' ' + 'p-button-' + (type ?? '') + ' ' + styleClass"
    [icon]="icon"
    [pTooltip]="tooltipText | i18next"
    tooltipPosition="top"
    (onClick)="onClick.emit($event)"
    [disabled]="disabled"
    [loading]="loading"
    [label]="label"
  ></p-button>
</div>
